import { render, staticRenderFns } from "./PopupOnMap.vue?vue&type=template&id=356a68a4&scoped=true&"
import script from "./PopupOnMap.vue?vue&type=script&lang=js&"
export * from "./PopupOnMap.vue?vue&type=script&lang=js&"
import style0 from "./PopupOnMap.vue?vue&type=style&index=0&id=356a68a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a68a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VOverlay,VProgressCircular})
